<script setup lang="ts">
import { definePage } from 'unplugin-vue-router/runtime'

import { useStoreData } from '@/stores/data'
import LayoutHeader from '@/layouts/header.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { pagesStructure } from './[groupId]/page/pages'
const { locale, t } = useI18n()

definePage({
  meta: {
    requireAuth: true
  }
})

const route = useRoute()
const { dataState } = useStoreData()

const currentGroup = computed(() => {
  return dataState.groups.find((g) => g.id === route.params.groupId)
})

/**
 * On adapte le nom du groupe,
 * si c'est Plongeurs Individuels, on le traduit
 * sinon, c'est le nom du club ou autre, on le laisse tel quel
 */
const currentGroupName = computed(() => {
  if (!currentGroup.value) return ''
  if (currentGroup.value.id === '46a3022d-775b-48c8-8fdc-05ee8b612f19')
    return t('capel.groups.' + currentGroup.value.id)
  return currentGroup.value.name
})

const pagesToDisplay = computed(() => {
  const pages = []
  for (const key in pagesStructure) {
    const currentPage = pagesStructure[key]
    if (currentPage.aclset_id === currentGroup.value?.aclset?.id) pages.push(currentPage)
  }
  return pages.sort((a, b) => (a.position > b.position ? 1 : 0))
})
</script>

<template>
  <suspense>
    <router-view v-slot="{ Component }">
      <layout-header
        v-slot="{ isSidebarDisplayed, toggleSidebar }"
        :display-menu-button="!!Component"
      >
        <template v-if="!currentGroup">
          No group available. It seems you're on the wrong way.
        </template>
        <div
          v-else
          class="relative flex min-h-full max-w-full flex-grow"
        >
          <aside
            class="w-full md:basis-72 bg-primary text-white grow-0 shrink-0 md:block shadow-lg border-r"
            :class="{
              hidden: !isSidebarDisplayed
            }"
          >
            <h1 class="text-3xl my-8 text-center">
              {{ currentGroupName }}
            </h1>

            <template
              v-for="page in pagesToDisplay"
              :key="page.id"
            >
              <router-link
                v-if="!page.hidden"
                :to="'/group/' + route.params.groupId + '/page/' + page.id"
                class="block p-4 hover:underline border-b"
                exact-active-class="bg-white text-primary"
                @click="toggleSidebar"
              >
                {{ pagesStructure[page.id].title[locale] }}
              </router-link>
            </template>
          </aside>
          <main class="w-full overflow-y-auto bg-slate-100 dark:bg-slate-900">
            <component
              :is="Component"
              v-if="Component"
            />
            <template v-else>
              <h1 class="text-3xl my-8 text-center text-primary">
                {{ currentGroupName }}
              </h1>

              <div class="w-full md:max-w-5xl mx-auto p-2 my-2 md:p-4">
                <p>
                  {{ t('capel.routes.groups.welcomeMessage') }}
                </p>

                <section class="flex gap-4 mt-8 flex-wrap justify-around">
                  <template
                    v-for="page in pagesToDisplay"
                    :key="page.id"
                  >
                    <router-link
                      v-if="!page.hidden"
                      :to="'/group/' + route.params.groupId + '/page/' + page.id"
                      class="flex items-center justify-center text-center rounded-md border p-4 hover:underline w-40 h-40 hover:shadow-md text-xl bg-white dark:text-white dark:bg-slate-800"
                    >
                      {{ pagesStructure[page.id].title[locale] }}
                    </router-link>
                  </template>
                </section>
              </div>
            </template>
          </main>
        </div>
      </layout-header>
    </router-view>

    <!-- loading state via #fallback slot -->
    <template #fallback>
      {{ t('capel.general.loading') }}...
    </template>
  </suspense>
</template>
